import ModalVideo from 'react-modal-video';
import React, { useState } from 'react';
import {BrowserRouter as  Routes, Link, Route} from 'react-router-dom'
export default function BannerFive(){
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
    return(
		<>
			<ModalVideo channel='youtube' isOpen={isOpen} videoId='S05bHj0LBE4' onClose={() => { openModal(); }} />
			<div id="slider-one" className="main-slider-area home-5">
			<div className="slider-bg-three">
				<div className="container">
					<div className="row align-items-center justify-content-center">
                    
						<div className="col-lg-12">
							<div className="slider__content3 text-center">
								<h5 className="sub-title mb-15">IT Software Solution &amp; Consultation</h5>
								<h1 className="main-title-four mb-50">Technology</h1>
								<div className="section-btn">
									<div className="rts-btn">
										<a href="#">Free Consultation</a>
									</div>
									<div className="rts-video">
										<div className="about-video-wrapper">
											<Link onClick={() => { openModal(); }} className="popup-video">
												<i className="far fa-play"></i>
											</Link>
										</div>
										<div className="video-desc">
											<p>Video Showcase</p>
											<p>Watch How it works?</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
        
    )
}